import TrackingStatus from '../../../../../../components/units/Management/AiAgent/Common/Tracking';

export default function AiAgentAsCsFileUploadStatusPage() {
  return <TrackingStatus trackingType="asCs" />;
}
